// extracted by mini-css-extract-plugin
export default {"titleText":"Zy5MyoA5","subtitleText":"_2v0GeF_d","withBackground":"_2-WDLBTR"};